import { Tile } from "@src/cloud-connect/blueprint/dashboards/entities/tile";

export class PutUpdateDashboardTilesPayloadBuilder {
  private dashboard_id: string;
  private source_id: string;
  private namespace: string;
  private tiles: Tile[];

  constructor(
    dashboard_id: string,
    source_id: string,
    namespace: string,
    tiles: Tile[],
  ) {
    this.dashboard_id = dashboard_id;
    this.source_id = source_id;
    this.namespace = namespace;
    this.tiles = tiles;
  }

  build() {
    return {
      dashboard_id: this.dashboard_id,
      source_id: this.source_id,
      namespace: this.namespace,
      data: {
        tiles: this.tiles,
      },
    };
  }
}
